import React from 'react';

export default function IconButton({
    children,
    onClick,
    className,
}: {
    children: React.ReactNode;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    className?: string;
}) {
    return (
        <button
            onClick={onClick}
            className={`focus:outline-none hover:bg-surface-muted transition-colors p-2 rounded-full inline-flex items-center ${className} text-foreground-secondary hover:text-foreground`}
            type="button"
        >
            {children}
        </button>
    );
}
